// One name for each barristers' clerk, used everywhere on the Fee Slips & Invoices page.
//
// The same clerk reached the page under three spellings: the paid summary form had its own
// list ("Holmes' List"), the fee slip form had Deadline Guard's codes ("Holmes"), and the fee
// slip list used whatever the statements and emails said ("Holmes List Barristers"). Here
// each clerk has one display name, matched to any spelling by clerkKey() (the same key the
// list already used to keep one group per clerk). Nothing stored is renamed: names are
// shown this way when read, and Deadline Guard is still sent its own code for a fee slip.
//
// To rename a clerk on the page, change its name here.

import { clerkKey } from "./clerkMatching.js";

export const CLERK_DIRECTORY = [
  { name: "Chapman's List", feeSlipCode: "Chapmans" },
  { name: "Dever's List", feeSlipCode: "Devers" },
  { name: "Foley's List", feeSlipCode: "Foleys" },
  { name: "Gordon & Jackson" },
  { name: "Greens List", feeSlipCode: "Greens" },
  { name: "Holmes List", feeSlipCode: "Holmes" },
  { name: "Howells' List" },
  { name: "Lennon's List" },
  { name: "List A" },
  { name: "List G" },
  { name: "Meldrum's List", feeSlipCode: "Meldrums" },
  { name: "Parnell's Barristers", feeSlipCode: "Parnells" },
  { name: "Patterson's List", feeSlipCode: "Pattersons" },
  { name: "Svenson Barristers" },
  { name: "Young's List" },
];

// Paid summaries can also be for invoices paid directly, not through a clerk.
export const DIRECT_INVOICE_PAYMENTS = "Direct Invoice Payments";

const byKey = new Map(CLERK_DIRECTORY.map((clerk) => [clerkKey(clerk.name), clerk]));

export function findClerk(name = "") {
  const key = clerkKey(name);
  return key ? byKey.get(key) || null : null;
}

// The page's name for a clerk, however it was spelled. A name the directory does not know
// (a new clerk, or one of the email intake's own groups) is shown as it is.
export function clerkDisplayName(name = "") {
  return findClerk(name)?.name || String(name || "").trim();
}

// The clerks a fee slip can be added for: only those Deadline Guard has a code for.
export const FEE_SLIP_CLERK_CHOICES = CLERK_DIRECTORY
  .filter((clerk) => clerk.feeSlipCode)
  .map((clerk) => ({ name: clerk.name, code: clerk.feeSlipCode }));

// The clerks a paid summary can be uploaded for.
export const PAID_SUMMARY_CLERKS = [...CLERK_DIRECTORY.map((clerk) => clerk.name), DIRECT_INVOICE_PAYMENTS];
